import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { NotifipopupPage } from './notifipopup';

@NgModule({
  declarations: [
    NotifipopupPage,
  ],
  imports: [
    IonicPageModule.forChild(NotifipopupPage),
  ],
})
export class NotifipopupPageModule {}



// WEBPACK FOOTER //
// ./src/pages/notifipopup/notifipopup.module.ts